//
//
//
//
//
//
//
//
//
//
//
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import FloatButton from "../components/FloatButton.vue";
export default {
  name: "home",
  components: {
    Header: Header,
    Footer: Footer,
    FloatButton: FloatButton
  },
  data: function data() {
    return {
      headerStyle: ""
    };
  },
  watch: {
    $route: {
      handler: function handler(route) {
        this.setHeaderCss(route.name);
      },
      // 深度观察监听
      deep: true
    }
  },
  created: function created() {
    this.$store.dispatch("get_user_info_friend");
    this.setHeaderCss(this.$route.name);
  },
  methods: {
    setHeaderCss: function setHeaderCss(name) {
      if (name == "Index") {
        this.headerStyle = "headerMin";
      } else {
        this.headerStyle = "";
      }
    }
  }
};